import React from 'react'
import RichCta from 'components/rich-cta'
import config from 'config'
import WidgetPage from 'components/hocs/widget-page'

const RichCtaApp = props => (
  <RichCta
    nmls
    url={`${config.credibleRoot}/mortgage`}
    title="Find the right mortgage for your dream home."
    body="Get your Streamlined Pre-approval in minutes."
    ctaText="Get Started"
    {...props}
  />
)

export default WidgetPage(RichCtaApp)
